
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lang/[locale]",
      function () {
        return require("private-next-pages/lang/[locale].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lang/[locale]"])
      });
    }
  